<template>
  <v-card id="downloadcard" class="mb-3 d-print-none lside-wdgt" max-width="350" width="100%" color="lsidebg" flat>   

    <v-card-title class="pt-2 pb-1 pl-2">
      <h5 class="wdgt-title ">{{$t('database.wdg_download')}} </h5>
    </v-card-title>

    <v-card-text v-if="doc" class="pt-0 pb-1">
      <h6 class="wdgt-subtitle mb-1">{{doctype}}</h6>
      <v-col class="flex-wrap px-0 py-0">
        <v-btn 
          dense small outlined color="link"
          :href="doc"
          class="mb-2 mr-2 text--link"
        >
          {{docname}}
        </v-btn>
        
        <!--Loop for Corrigendum-->
        <template v-if="corrs.length>=1">
          <v-btn v-for="corr in corrs" :key="corr.cnt"
            dense small outlined color="link"
            :href="corr.doc" 
            class="mb-2 mr-2 text--link"
          >
            {{$t('database.corrigendum')}} <span v-if="corrs.length>1" class="ml-1" >No.{{corr.cnt}}</span> 
          </v-btn>
        </template>

      </v-col>
    </v-card-text>
    
  </v-card>
</template>

<script>
  export default {
    name: 'DownloadWidget',
    props: {
      doc: {type: String, default: ''},
      docname: {type: String, default: ''},
      doctype: {type: String, default: ''},
      printable: {type: Boolean, default: true},
      corrs: {
        type: Array,
        default(){
          return []
        }
      }
    },
    methods: {
      print(){
        window.print()
      }
    }
  }
</script>